import React, { useEffect, useState } from "react";
import { Organization } from "../common/ObjectTypes";
import { toast } from "react-toastify";
import {
  createOrganization,
  deleteOrganization,
  searchOrganizations,
  updateOrganization,
} from "../../api/organizations/organizationsApi";
import OrgnizationsController from "./OrganizationsList";
import { useNavigate } from "react-router-dom";

const ManageCountriesController = () => {
  const [pageLoaded, setPageLoaded] = useState(false);
  const navigate = useNavigate();
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [addOrganization, setAddOrganization] = useState(false);
  const [selectedOrganization, setSelectedOrganization] =
    useState<Organization>({
      name: "",
      organizationId: "",
      rowVersion: "",
    });
  const [organizationToAdd, setOrganizationToAdd] = useState<Organization>({
    name: "",
    organizationId: "",
    rowVersion: "",
  });
  const [query, setQuery] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [recordStart, setRecordStart] = useState(1);
  const [recordEnd, setRecordEnd] = useState(0);
  const pageSize = 25;
  const [reloadPage, setReloadPage] = useState(true);
  const [searchQuery, setSearchQuery] = useState({
    name: "",
    pageNumber: 1,
    pageSize: pageSize,
  });

  useEffect(() => {
    const loadOrganizations = async () => {
      setLoading(true);
      try {
        const temp = await searchOrganizations(searchQuery);
        setOrganizations(temp.results);
        setPageCount(Math.ceil(temp.totalCount / pageSize));
        setTotalCount(temp.totalCount);
        const start = (searchQuery.pageNumber - 1) * searchQuery.pageSize + 1;
        const end = Math.min(start + temp.results.length - 1, temp.totalCount);

        setRecordStart(start);
        setRecordEnd(end);
        setReloadPage(false);
        setPageLoaded(true);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    loadOrganizations();
  }, [pageLoaded, reloadPage]);

  const handleOnClickAdd = () => {
    navigate("/organization/add");
  };

  const handleSelectOrg = (org_id: Organization) => {
    navigate(`/organization/${org_id}/edit`);
  };

  const handlePageClick = (selectedItem: { selected: number }) => {
    setSearchQuery((prevQuery) => ({
      ...prevQuery,
      pageNumber: selectedItem.selected + 1,
    }));
    setReloadPage(true);
  };

  const handleSearch = async (e: any) => {
    try {
      setSearchQuery((prevQuery) => ({
        ...prevQuery,
        name: searchQuery.name || "",
        pageNumber: 1,
      }));
      setReloadPage(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery((prevQuery: any) => ({
      ...prevQuery,
      name: event.target.value,
    }));
  };

  return (
    <div className="h-screen">
      <OrgnizationsController
        organizations={organizations}
        selectedOrg={selectedOrganization}
        orgToAdd={organizationToAdd}
        addOrg={addOrganization}
        onClickAdd={handleOnClickAdd}
        onSelectOrg={handleSelectOrg}
        pageCount={pageCount}
        totalCount={totalCount}
        handlePageClick={handlePageClick}
        recordStart={recordStart}
        recordEnd={recordEnd}
        pageSize={pageSize}
        onChangeSearch={handleChangeFilter}
        onSearch={handleSearch}
        searchQuery={searchQuery}
        loading={loading}
      />
    </div>
  );
};

export default ManageCountriesController;
